// extracted by mini-css-extract-plugin
export var bottomRightDock = "_2d-0";